import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import axios from 'axios'

import Header from './components/Header'
import Home from './pages/Home'
import Project from './pages/Project'
import About from './pages/About'
import Contact from './pages/Contact'

class App extends Component {
  constructor (props) {
    super(props)

    this.state = {
      projects: {},
      textColor: '#545352',
      backgroundColor: '#efeae6'
    }

    this.changeHeaderColors = this.changeHeaderColors.bind(this)
  }

  componentWillMount () {
    axios.get('/projectsList.json')
    .then(response => {
      return this.setState({
        projects: response.data
      })
    })
    .catch(error => {
      console.log(error)
    })
  }

  changeHeaderColors (textColor, backgroundColor) {
    window.scroll(0, 0)
    document.querySelector('body').style.background = backgroundColor
    return this.setState({ textColor, backgroundColor })
  }

  render () {
    return (
      <div className='App' style={{
        background: `${this.state.backgroundColor}`,
        color: `${this.state.textColor}`
      }}>
        <Header textColor={this.state.textColor} backgroundColor={this.state.backgroundColor} />
        <Switch>
          <Route exact path='/'>
            <Home projects={this.state.projects} changeHeaderColors={this.changeHeaderColors} />
          </Route>
          <Route exact path='/project/:name' children={({ match }) => (
            <Project projects={this.state.projects} changeHeaderColors={this.changeHeaderColors} match={match} />
          )} />
          <Route exact path='/about'>
            <About changeHeaderColors={this.changeHeaderColors} />
          </Route>
          <Route exact path='/contact'>
            <Contact changeHeaderColors={this.changeHeaderColors} />
          </Route>
        </Switch>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js